import { toast } from "sonner";
import { BUILD_INFO } from "@/buildInfo";

// Formatuje ISO na czytelną datę PL (YYYY-MM-DD HH:MM)
function fmt(iso) {
  try {
    const d = new Date(iso);
    const p = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
  } catch {
    return iso || "";
  }
}

export default function BuildBadge() {
  const built = fmt(BUILD_INFO.builtAt);
  const ver = BUILD_INFO.version ? `v${BUILD_INFO.version}` : "";
  const full = `FiberPass ${ver} · build ${built}`;
  return (
    <button
      type="button"
      data-testid="build-badge"
      title={full}
      onClick={() => toast.info(full, { description: "Jeśli po aktualizacji paczki data buildu się nie zmienia, odśwież przeglądarkę (Ctrl+Shift+R) lub przebuduj frontend na serwerze." })}
      className="fixed bottom-1 left-1/2 -translate-x-1/2 z-[1200] px-2 py-0.5 rounded-full bg-slate-900/80 hover:bg-slate-800 border border-slate-700/70 text-[10px] font-mono text-slate-400 hover:text-cyan-300 backdrop-blur transition-colors select-none shadow-lg"
    >
      {ver} · {built}
    </button>
  );
}
